import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import Index from "./pages/Index";
import IndexVi from "./pages/IndexVi";
import IndexTw from "./pages/IndexTw";
import IndexKr from "./pages/IndexKr";
import IndexJp from "./pages/IndexJp";
import IndexCn from "./pages/IndexCn";
import OnlineWorkspace from "./pages/OnlineWorkspace";
import ProductivityTool from "./pages/ProductivityTool";
import StudyStreamPage from "./pages/StudyStream";
import Reminders from "./pages/Reminders";
import StudyTimer from "./pages/StudyTimer";
import TaskManagement from "./pages/TaskManagement";
import Quizzes from "./pages/Quizzes";
import FlashCards from "./pages/FlashCards";
import StudyRoom from "./pages/StudyRoom";
import StudyVerse from "./pages/StudyVerse";
import StudyWithSKZ from "./pages/StudyWithSKZ";
import StudyWithItzy from "./pages/StudyWithItzy";
import StudyWithBlackpink from "./pages/StudyWithBlackpink";
import StudyWithAespa from "./pages/StudyWithAespa";
import StudyWithTwice from "./pages/StudyWithTwice";
import StudyWithAteez from "./pages/StudyWithAteez";
import StudyWithKpop from "./pages/StudyWithKpop";
import StudyWithMe from "./pages/StudyWithMe";
import StudyWithFriends from "./pages/StudyWithFriends";
import StudyWithStrangers from "./pages/StudyWithStrangers";
import GroupStudy from "./pages/GroupStudy";
import ZoomStudyRoom from "./pages/ZoomStudyRoom";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import UserRegistrationPolicy from "./pages/UserRegistrationPolicy";
import ContentMonitoringPolicy from "./pages/ContentMonitoringPolicy";
import ReportPolicy from "./pages/ReportPolicy";
import Blog from "./pages/Blog";
import HowTurningOnMyCameraBoostedMyProductivity from "./pages/blog/HowTurningOnMyCameraBoostedMyProductivity";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/vn/" element={<IndexVi />} />
          <Route path="/tw/" element={<IndexTw />} />
          <Route path="/kr/" element={<IndexKr />} />
          <Route path="/jp/" element={<IndexJp />} />
          <Route path="/cn/" element={<IndexCn />} />
            <Route path="/online-workspace/" element={<OnlineWorkspace />} />
            <Route path="/productivity-tool/" element={<ProductivityTool />} />
            <Route path="/studystream/" element={<StudyStreamPage />} />
            <Route path="/study-stream/" element={<Navigate to="/studystream/" replace />} />
            <Route path="/study-stream" element={<Navigate to="/studystream/" replace />} />
            <Route path="/reminders/" element={<Reminders />} />
            <Route path="/study-timer/" element={<StudyTimer />} />
            <Route path="/task-management/" element={<TaskManagement />} />
            <Route path="/quizzes/" element={<Quizzes />} />
            <Route path="/flash-cards/" element={<FlashCards />} />
            <Route path="/study-room/" element={<StudyRoom />} />
            <Route path="/studyverse/" element={<StudyVerse />} />
            <Route path="/study-with-skz/" element={<StudyWithSKZ />} />
            <Route path="/study-with-itzy/" element={<StudyWithItzy />} />
            <Route path="/study-with-blackpink/" element={<StudyWithBlackpink />} />
            <Route path="/study-with-aespa/" element={<StudyWithAespa />} />
            <Route path="/study-with-twice/" element={<StudyWithTwice />} />
            <Route path="/study-with-ateez/" element={<StudyWithAteez />} />
            <Route path="/study-with-kpop/" element={<StudyWithKpop />} />
            <Route path="/study-with-me/" element={<StudyWithMe />} />
            <Route path="/study-with-friends/" element={<StudyWithFriends />} />
            <Route path="/study-with-strangers/" element={<StudyWithStrangers />} />
            <Route path="/group-study/" element={<GroupStudy />} />
            <Route path="/zoom-study-room/" element={<ZoomStudyRoom />} />
            <Route path="/privacy-policy/" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use/" element={<TermsOfUse />} />
            <Route path="/registration-policy/" element={<UserRegistrationPolicy />} />
            <Route path="/content-monitoring-policy/" element={<ContentMonitoringPolicy />} />
            <Route path="/report-policy/" element={<ReportPolicy />} />
            <Route path="/blog/" element={<Blog />} />
            <Route path="/blog/how-turning-on-my-camera-boosted-my-productivity/" element={<HowTurningOnMyCameraBoostedMyProductivity />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
